<button mat-icon-button class="close-dialog-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h2 mat-dialog-title>Seleccionar Establecimiento</h2>
<mat-dialog-content class="mat-typography">
  <div flexLayout="column">
    <div
      flexLayout="row"
      *ngIf="establecimientosMatrices && establecimientosMatrices.length > 0"
      class="contenedor-establecimientos"
    >
      <mat-icon style="font-size: 80px; margin-top: 15px" fxFlex="10"
        >account_balance</mat-icon
      >
      <mat-table
        fxFlex="90"
        mat-table
        [dataSource]="establecimientosMatrices"
        class="mat-elevation-z0 custom"
      >
        <ng-container matColumnDef="establecimiento">
          <mat-header-cell class="hidden" *matHeaderCellDef
            >Numero</mat-header-cell
          >
          <mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.numero }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="tipo">
          <mat-header-cell class="hidden" *matHeaderCellDef
            >Tipo</mat-header-cell
          >
          <mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
            >{{ element.tipo }}</mat-cell
          >
        </ng-container>
        <ng-container matColumnDef="nombreComercial">
          <mat-header-cell class="hidden" *matHeaderCellDef
            >Nombre Comercial</mat-header-cell
          >
          <mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
            >{{ element.nombreComercial }}</mat-cell
          >
        </ng-container>
        <ng-container matColumnDef="ubicacion">
          <mat-header-cell class="hidden" *matHeaderCellDef
            >Ubicación</mat-header-cell
          >
          <mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
            >{{ element.parroquia.canton.cantonName }}</mat-cell
          >
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedColumnsMatrices"
        ></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumnsMatrices"
          matRipple
        ></mat-row>
      </mat-table>
    </div>
    <div
      flexLayout="row"
      *ngIf="establecimientosFiliales && establecimientosFiliales.length > 0"
      class="contenedor-establecimientos"
    >
      <mat-icon style="font-size: 80px; margin-top: 15px" fxFlex="10"
        >book</mat-icon
      >
      <table
        fxFlex="90"
        mat-table
        [dataSource]="establecimientosFiliales"
        class="mat-elevation-z0"
      >
        <ng-container matColumnDef="establecimiento">
          <th class="hidden" mat-header-cell *matHeaderCellDef>Numero</th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.numero }}
          </td>
        </ng-container>
        <ng-container matColumnDef="tipo">
          <th class="hidden" mat-header-cell *matHeaderCellDef>Tipo</th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.tipo }}
          </td>
        </ng-container>
        <ng-container matColumnDef="nombreComercial">
          <th class="hidden" mat-header-cell *matHeaderCellDef>
            Nombre Comercial
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.nombreComercial }}
          </td>
        </ng-container>
        <ng-container matColumnDef="ubicacion">
          <th class="hidden" mat-header-cell *matHeaderCellDef>Ubicación</th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.parroquia.canton.cantonName }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsFiliales"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumnsFiliales"
        ></tr>
      </table>
    </div>
    <div
      flexLayout="row"
      *ngIf="
        establecimientosUnidadesNegocios &&
        establecimientosUnidadesNegocios.length > 0
      "
      class="contenedor-establecimientos"
    >
      <mat-icon style="font-size: 80px; margin-top: 15px" fxFlex="10"
        >account_balance_wallet</mat-icon
      >
      <table
        fxFlex="90"
        mat-table
        [dataSource]="establecimientosUnidadesNegocios"
        class="mat-elevation-z0"
      >
        <ng-container matColumnDef="establecimiento">
          <th class="hidden" mat-header-cell *matHeaderCellDef>Numero</th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.numero }}
          </td>
        </ng-container>
        <ng-container matColumnDef="tipo">
          <th class="hidden" mat-header-cell *matHeaderCellDef>Tipo</th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.tipo }}
          </td>
        </ng-container>
        <ng-container matColumnDef="nombreComercial">
          <th class="hidden" mat-header-cell *matHeaderCellDef>
            Nombre Comercial
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.nombreComercial }}
          </td>
        </ng-container>
        <ng-container matColumnDef="ubicacion">
          <th class="hidden" mat-header-cell *matHeaderCellDef>Ubicación</th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.parroquia.canton.cantonName }}
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumnsUnidadesNegocios"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumnsUnidadesNegocios"
        ></tr>
      </table>
    </div>
    <div
      flexLayout="row"
      *ngIf="
        establecimientosSucursales && establecimientosSucursales.length > 0
      "
      class="contenedor-establecimientos"
    >
      <mat-icon style="font-size: 80px; margin-top: 15px" fxFlex="10"
        >bookmars</mat-icon
      >
      <table
        fxFlex="90"
        mat-table
        [dataSource]="establecimientosSucursales"
        class="mat-elevation-z0"
      >
        <ng-container matColumnDef="establecimiento">
          <th class="hidden" mat-header-cell *matHeaderCellDef>Numero</th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.numero }}
          </td>
        </ng-container>
        <ng-container matColumnDef="tipo">
          <th class="hidden" mat-header-cell *matHeaderCellDef>Tipo</th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.tipo }}
          </td>
        </ng-container>
        <ng-container matColumnDef="nombreComercial">
          <th class="hidden" mat-header-cell *matHeaderCellDef>
            Nombre Comercial
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.nombreComercial }}
          </td>
        </ng-container>
        <ng-container matColumnDef="ubicacion">
          <th class="hidden" mat-header-cell *matHeaderCellDef>Ubicación</th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.parroquia.canton.cantonName }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsSucursales"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumnsSucursales"
        ></tr>
      </table>
    </div>
    <div
      flexLayout="row"
      *ngIf="establecimientosAgencias && establecimientosAgencias.length > 0"
      class="contenedor-establecimientos"
    >
      <mat-icon style="font-size: 80px; margin-top: 15px" fxFlex="10"
        >accesibility</mat-icon
      >
      <table
        fxFlex="90"
        mat-table
        [dataSource]="establecimientosAgencias"
        class="mat-elevation-z0"
      >
        <ng-container matColumnDef="establecimiento">
          <th class="hidden" mat-header-cell *matHeaderCellDef>Numero</th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.numero }}
          </td>
        </ng-container>
        <ng-container matColumnDef="tipo">
          <th class="hidden" mat-header-cell *matHeaderCellDef>Tipo</th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.tipo }}
          </td>
        </ng-container>
        <ng-container matColumnDef="nombreComercial">
          <th class="hidden" mat-header-cell *matHeaderCellDef>
            Nombre Comercial
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.nombreComercial }}
          </td>
        </ng-container>
        <ng-container matColumnDef="ubicacion">
          <th class="hidden" mat-header-cell *matHeaderCellDef>Ubicación</th>
          <td
            mat-cell
            *matCellDef="let element"
            class="pointer"
            (click)="seleccionar(element)"
          >
            {{ element.parroquia.canton.cantonName }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsAgencias"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumnsAgencias"
        ></tr>
      </table>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close (click)="onNoClick()">
    Cancelar
  </button>
</mat-dialog-actions>
